import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';

import useCountryRequest from '../../requests/CountryRequest';
import { Chip, TextField } from '@mui/material';

const cachedCountries = [];

export default function CountryAutocomplete({
  value,
  onBlur,
  onChipDelete,
  errorHandler,
  ...props
}) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const { getCountries } = useCountryRequest();

  useEffect(() => {
    const loadCountries = async () => {
      if (countries.length) return;
      try {
        setLoading(true);
        const countriesData = await getCountries(errorHandler);
        cachedCountries.push(...countriesData);
        setCountries(countriesData || []);
      } catch (error) {
        console.error('Error loading countries:', error);
      } finally {
        setLoading(false);
      }
    };

    if (cachedCountries.length) {
      setCountries(cachedCountries);
      return;
    }

    loadCountries();
  }, []);

  const getOptionObj = (option) => {
    if (typeof option === 'object') return option;

    const country = countries.find(
      (c) => c.country_code_id === parseInt(option)
    );
    return country;
  };

  return (
    <Autocomplete
      value={value || []}
      options={countries || []}
      getOptionLabel={(option) => getOptionObj(option).country_name}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Select..."
          onBlur={onBlur}
          sx={{
            '& .MuiAutocomplete-input': {
              '&::placeholder': {
                color: 'grey',
              },
            },
          }}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const obj = getOptionObj(option);

          return (
            <Chip
              {...getTagProps({ index })}
              key={`${obj?.country_code_id}_${index}`}
              label={obj?.country_name}
            />
          );
        })
      }
      slotProps={{
        popper: {
          sx: {
            border: `2px solid`,
            borderColor: 'secondary.light',
            borderRadius: 2,
            overflow: 'hidden',
          },
        },
        listbox: {
          sx: {
            padding: 0,
          },
        },
      }}
      loading={loading}
      loadingText="Loading..."
      isOptionEqualToValue={(option, val) =>
        option.country_code_id === val.country_code_id
      }
      multiple
      clearOnBlur
      disableCloseOnSelect
      handleHomeEndKeys
      {...props}
    />
  );
}
